<template>
  <div class="singleProgramItem_slotPop" v-if="options">
    <div class="optionGroup" v-for="group in options" :key="group.key">
      <span class="optionGroup_title">
        <!-- <span class="title_icon" :class="group.key"></span> -->
        <span class="name" v-text="group.title"></span>
      </span>
      <span class="optionGroup_right">
        <span class="optionItem_select" v-if="group.type === 'DatePicker'">
          <el-date-picker
            v-model="group.value"
            value-format="yyyy-MM-dd"
            popper-class="datePicker_publickThemeDialog small"
            type="date"
            placeholder="请选择日期"
          ></el-date-picker>
        </span>

        <span class="optionItem_select" v-if="group.type === 'TimePicker'">
          <el-time-picker
            arrow-control
            v-model="group.value"
            popper-class="datePicker_publickThemeDialog small"
            placeholder="请选择时间"
            :picker-options="{
              format: 'HH:mm',
            }"
            value-format="HH:mm"
            @change="timePickerChange"
          ></el-time-picker>
        </span>

        <span class="optionItem_select" v-if="group.type === 'select'">
          <el-select
            v-model="group.value"
            placeholder="请选择频道"
            popper-class="datePicker_publickThemeDialog optionItem_select"
          >
            <el-option
              v-for="item in group.list"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </span>

        <span class="optionItem_select" v-if="group.type === 'input'">
          <el-input
            placeholder="请输入内容"
            type="textarea"
            :autosize="{ minRows: 1, maxRows: 4 }"
            v-model="group.value"
            clearable
          ></el-input>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
// 节目单 => 创建节目单 【添加单个节目单】时的组件
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'singleProgramItem_slotPop',
  mixins: [cup_base_data_mixin],
  props: {
    options: {
      // 每一个组件这里的存储的结构不一样
      type: [Array, null],
      default: null,
    },
  },
  data() {
    return {}
  },
  created() {
    // 模拟数据
    console.debug(this.datas)
  },
  methods: {
    timePickerChange(val) {
      console.debug(val)
    },
    _valFormatHandler(val, text, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (text) {
          data = `${text}: ${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss">
.singleProgramItem_slotPop {
  .optionGroup {
    width: 100%;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 1.1vw;
    &:first-child {
      margin-top: 0;
    }
    .optionGroup_title {
      width: 6.94vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      color: var(--mixtmt_greyColor3);
      /* .title_icon {
                width: 1.388vw;
                height: 1.388vw;
                overflow: hidden;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                background-position: center;
                background-color: var(--mixtmt_greyColor8);
              } */
      .name {
        width: 100%;
        padding-right: 0.694vw;
        font-size: 1.11vw;
        line-height: 1.388vw;
        text-align: right;
      }
    }
    .optionGroup_right {
      width: calc(100% - 6.94vw);
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .optionItem_select {
        opacity: 1;
        .el-input__inner {
          width: 20.83vw;
          height: 2.778vw;
          line-height: 2.778vw;
        }
        .el-input--prefix .el-input__inner {
          padding-left: 3vw;
        }
        .el-input--suffix .el-input__inner {
          padding-right: 3vw;
        }
        .el-textarea {
          width: 20.83vw;
        }
      }
    }
    .el-time-spinner__wrapper.is-arrow
      .el-time-spinner__item:hover:not(.disabled):not(.active) {
      background: transparent;
    }
  }
}
</style>
